import React from 'react';
import { TipsMapType } from '../index';


export const channelShareRankingPublicationsTitleTips: TipsMapType = {
  en: (
    <>
      Click to visit the game's [Feeds] Page.<br />
      Note: Content may differ after redirection as this
      page uses Levelup data only.
    </>
  ),
  zh: (
    <>
      点击跳转该游戏【评论/资讯详情页】。<br />
      注意：由于本页面仅展示Levelup平台数据，跳转后展示内容可能与此处不同。
    </>
  ),
};

export const channelShareRankingHashTagTitleTips: TipsMapType = {
  en: (
    <>
      Click to visit the game's [Hashtag] Page.<br />
      Note: Content may differ after redirection as this
      page uses Levelup data only.
    </>
  ),
  zh: (
    <>
      点击跳转该游戏【Hashtag页】。<br />
      注意：由于本页面仅展示Levelup平台数据，跳转后展示内容可能与此处不同。
    </>
  ),
};